import Navbar from "./Navbar";
import Footer from "./Footer";
import "./Leaderboard.scss";
import { useEffect, useState } from "react";

import gmBronze from "../assets/gmBronze.png";
import gmSilver from "../assets/gmSilver.png";
import gmGold from "../assets/gmGold.png";
import gmExplainer from "../assets/gms-explained.png";
import { Link } from "react-router-dom";

const Leaderboard = () => {
  const [leaderboardData, setLeaderboardData] = useState<any[]>([]);
  const [sortedLeaderboardData, setSortedLeaderboardData] = useState<any[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchLeaderboardData = async () => {
    const response = await fetch(
      "https://replyguys-backend.herokuapp.com/api/users/all"
    );
    const data = await response.json();
    setLeaderboardData(data);
  };

  useEffect(() => {
    fetchLeaderboardData();
  }, []);

  useEffect(() => {
    if (leaderboardData.length > 0) {
      setSortedLeaderboardData(
        [...leaderboardData].sort((a, b) => b.totalPoints - a.totalPoints)
      );
    }
  }, [leaderboardData]);

  console.log(sortedLeaderboardData);

  return (
    <>
      <Navbar />
      <section className="section">
        <div className="">
          <div className="container has-text-centered">
            <div className="has-text-centered my-6" id="title">
              Leaderboard
            </div>
            <div className="has-text-centered my-6 leaderboard-explainer">
              The ultimate bragging rights. Keep track of your hard-earned GMs
              here. Don't know how GMs work? Check out our guide&nbsp;
              <span
                className="gm-popup-link"
                onClick={() => setIsModalOpen(true)}
              >
                here
              </span>
              .&nbsp;Can't find yourself? Signing up to our&nbsp;
              <Link className="link-to-gminator" to="/classified">
                GMinator&nbsp;
              </Link>
              might help
            </div>
            <div className="table-container is-centered">
              <div className="table-body-container">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Rank</th>
                      <th>Username</th>
                      <th>PTS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedLeaderboardData
                      .filter(
                        (data) =>
                          data.twitterUsername !== "0xVarano" &&
                          data.twitterUsername !== "ape_gainz" &&
                          data.twitterUsername !== "captainkong_eth"
                      )
                      .slice(0, 50)
                      .map((data, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td className="username-cell">
                            {index === 0 && (
                              <img
                                className="leaderboard-medal"
                                src={gmGold}
                                alt="Gold"
                              />
                            )}
                            {index === 1 && (
                              <img
                                className="leaderboard-medal"
                                src={gmSilver}
                                alt="Silver"
                              />
                            )}
                            {index === 2 && (
                              <img
                                className="leaderboard-medal"
                                src={gmBronze}
                                alt="Bronze"
                              />
                            )}
                            <a
                              target="_blank"
                              href={`https://twitter.com/${data.twitterUsername}`}
                              rel="noreferrer"
                              className="leaderboard-twitter-profile"
                            >
                              @{data.twitterUsername}
                            </a>
                          </td>
                          <td>{data.totalPoints}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className={`modal ${isModalOpen ? "is-active" : ""}`}>
        <div
          className="modal-background"
          onClick={() => setIsModalOpen(false)}
        ></div>
        <div className="modal-card">
          <header className="modal-card-head modal-leaderboard-head">
            <button
              className="delete"
              aria-label="close"
              onClick={() => setIsModalOpen(false)}
            ></button>
          </header>
          <section className="modal-card-body">
            <img src={gmExplainer} alt="gms explained"></img>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Leaderboard;
